/**
 * Small pill/badge built on the `.badge` component class from index.css.
 * Colour presets cover the common status semantics used across the app.
 */
import type { ReactElement, ReactNode } from 'react';

export type BadgeColor = 'gray' | 'green' | 'red' | 'yellow' | 'blue' | 'brand';

export interface BadgeProps {
  color?: BadgeColor;
  children: ReactNode;
  className?: string;
}

const colorMap: Record<BadgeColor, string> = {
  gray: 'bg-gray-100 text-gray-800',
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  blue: 'bg-blue-100 text-blue-800',
  brand: 'bg-brand-100 text-brand-800',
};

/** Coloured status badge. */
export default function Badge({ color = 'gray', children, className = '' }: BadgeProps): ReactElement {
  return <span className={`badge ${colorMap[color]} ${className}`.trim()}>{children}</span>;
}
